import React, { Component } from "react";

import "./dashedLineBreak.css";

export default class DashedLineBreak extends Component {
  render() {
    return <div className="dashedLineBreak" />;
  }
}
